import Section from 'app/frontend/base/components/Section'
import UserSettingsTeamSection from './components/UserSettingsTeamSection'
import UserSettingsPrivacySection from './components/UserSettingsPrivacySection'
import UserSettingsNotificationSection from './components/UserSettingsNotificationSection'
import EntitySettings from 'app/frontend/base/components/EntitySettings'

const UserSettings = () => {
  return (
    <Section title='Profile'>
      <EntitySettings
        entityType='user'
        defaultSection='privacy'
        className='max-w-200'
        sections={{
          privacy: UserSettingsPrivacySection,
          notifications: UserSettingsNotificationSection,
          teams: UserSettingsTeamSection,
        }}
      />
    </Section>
  )
}

export default UserSettings
